/* eslint-disable */
<template>
	<div id="strategylist">
		<!-- Tab栏 -->
		<div class="tab-bar">
			<div class="tab-item" :class="{ active: currentTab === 'all' }" @click="switchTab('all')">
				<span class="tab-text">全部</span>
				<div v-if="currentTab === 'all'" class="tab-indicator"></div>
			</div>
			<div class="tab-item" :class="{ active: currentTab === 'aggressive' }" @click="switchTab('aggressive')">
				<span class="tab-text">激进</span>
				<div v-if="currentTab === 'aggressive'" class="tab-indicator"></div>
			</div>
			<div class="tab-item" :class="{ active: currentTab === 'stable' }" @click="switchTab('stable')">
				<span class="tab-text">稳健</span>
				<div v-if="currentTab === 'stable'" class="tab-indicator"></div>
			</div>
		</div>

		<!-- 列表区域 -->
		<div class="scroll-view">
			<!-- 顶部占位 -->
			<div class="list-top-spacer"></div>
			<div v-for="(item, index) in filteredList" :key="index" class="card-item teacher-card"
				@click="showDetail(item)">
				<!-- 背景图 -->
				<div class="card-bg" :style="{ borderImageSource: 'url(' + bgTeacher + ')' }"></div>
				
				<!-- 右上角标签 - 根据策略类型显示 -->
				<img class="card-tag-img" :src="item.strategyType === 'premium' ? premiumTag : classicTag" alt="" />

				<!-- 标题行 (独立出来以避免被遮罩) -->
				<div class="card-header" style="padding: 22px 24px 0 24px; margin-bottom: 0;">
					<div class="card-name-row">
						<div class="card-name-group" style="position: relative; z-index: 20;">
							<span class="card-name">{{ getStrategyNameEn(item) }}</span>
							<span class="card-name-zh">{{ getStrategyNameZh(item) }}</span>
						</div>
						<div class="arrow-wrap">
							<van-icon name="arrow" color="#999999" size="14" />
						</div>
					</div>
				</div>

				<!-- 卡片内容 -->
				<div class="card-content" style="padding-top: 16px;">

					<!-- 第二行：收益数据 -->
					<div class="card-data">
						<div class="data-item">
							<span class="data-value red">{{ formatPercent(getYearReturn(item)) }}</span>
							<span class="data-label">近一年收益</span>
						</div>
						<div class="data-item">
							<span class="data-value black">{{ formatPercent(getAnnualReturn(item)) }}</span>
							<span class="data-label">年化收益</span>
						</div>
						<div class="data-item right-align">
							<span class="data-value risk">{{ getRiskType(item) }}</span>
							<span class="data-label">风险类型</span>
						</div>
					</div>

					<!-- 第三行：已订阅 + 订阅人数 -->
					<div class="card-footer">
						<div v-if="getSubscribeStatus(item)" class="subscribed-tag">
							<span class="subscribed-text">已订阅</span>
						</div>
						<div class="footer-spacer"></div>
						<div class="subscriber-info">
							<span class="subscriber-label">订阅人数 </span>
							<span class="subscriber-count">{{ item.subscribers || 0 }}</span>
						</div>
					</div>
				</div>

				<!-- 遮罩层（无权限时显示） -->
				<div v-if="item.accessLevel === 3" class="card-blur-overlay">
					<div class="lock-icon-wrap">
						<img class="lock-icon" :src="lockIcon" alt="lock" />
					</div>
				</div>
			</div>

			<!-- 底部安全区 -->
			<div class="bottom-safe"></div>
		</div>
		
		<div class="bottom">
			<the-tabbar active-page="teacher" />
		</div>
		
		<subscribe-prompt-popup v-model="showPrompt" @contact="onContactCustomerService" @purchase="onPurchaseServer" />
	</div>
</template>
<script>
import TheTabbar from '@/components/theTabbar.vue'
import { Icon, Toast } from 'vant'
import { islogin, logout, fetchGoodStrategylistV3 } from '@/api/theApi'
import bgTeacher from '@/assets/strategy/bg_teacher.png'
import classicTag from '@/assets/strategy/classic.png'
import premiumTag from '@/assets/strategy/premium.png'
import lockIcon from '@/assets/strategy/lock.png'
import SubscribePromptPopup from '@/components/SubscribePromptPopup.vue'
import { openUseasyWebChat } from '@/utils/useasyKeFu.js'

export default {
	components: {
		[Icon.name]: Icon,
		TheTabbar,
		SubscribePromptPopup,
	},
	data() {
		return {
			currentTab: 'all',
			goodList: [],
			unlogin: false,
			bgTeacher,
			classicTag,
			premiumTag,
			lockIcon,
			showPrompt: false,
		}
	},
	computed: {
		filteredList() {
			if (this.currentTab === 'all') {
				return this.goodList;
			} else if (this.currentTab === 'aggressive') {
				return this.goodList.filter(item => {
					return this.getRiskType(item) === '激进';
				});
			} else if (this.currentTab === 'stable') {
				return this.goodList.filter(item => {
					return this.getRiskType(item) === '稳健';
				});
			}
			return this.goodList;
		}
	},
	created() {
		this.init()
	},
	methods: {
		getMetric(item, keys) {
			if (!item || !keys || !keys.length) return undefined
			for (let i = 0; i < keys.length; i += 1) {
				const key = keys[i]
				if (Object.prototype.hasOwnProperty.call(item, key)) {
					const value = item[key]
					if (value !== undefined && value !== null && value !== '') return value
				}
			}
			return undefined
		},
		getStrategyName(item) {
			return this.getMetric(item, ['name', 'strategyName', 'strategy_name', 'title']) || ''
		},
		getStrategyNameEn(item) {
			const name = this.getStrategyName(item);
			const index = name.indexOf('(') !== -1 ? name.indexOf('(') : name.indexOf('（');
			return index !== -1 ? name.substring(0, index) : name;
		},
		getStrategyNameZh(item) {
			const name = this.getStrategyName(item);
			const index = name.indexOf('(') !== -1 ? name.indexOf('(') : name.indexOf('（');
			return index !== -1 ? name.substring(index) : '';
		},
		getYearReturn(item) {
			return this.getMetric(item, ['dayReturn252', 'day_return_252', 'day_return252', 'total_return', 'totalReturn'])
		},
		getAnnualReturn(item) {
			return this.getMetric(item, ['annualizedReturn', 'annualized_return'])
		},
		getRiskType(item) {
			const risk = this.getMetric(item, ['riskType', 'risk_type'])
			return risk ? String(risk).trim() : '-'
		},
		getSubscribeStatus(item) {
			return Boolean(this.getMetric(item, ['subscribeStatus', 'subscribe_status', 'subscribed']))
		},
		formatPercent(value) {
			if (value === null || value === undefined) return '--'
			if (typeof value === 'string') {
				const trimmed = value.trim()
				if (!trimmed) return '--'
				if (trimmed.includes('%')) return trimmed
				const num = Number(trimmed)
				if (Number.isFinite(num)) return `${num >= 0 ? '+' : ''}${num.toFixed(2)}%`
				return trimmed
			}
			if (typeof value === 'number' && Number.isFinite(value)) {
				return `${value >= 0 ? '+' : ''}${value.toFixed(2)}%`
			}
			return '--'
		},
		switchTab(tab) {
			this.currentTab = tab;
		},
		async init() {
			const isloginRes = await islogin()
			const username = localStorage.getItem('username')

			try {
				const res = await fetchGoodStrategylistV3(username || '');
				if (res && res.data) {
					this.goodList = res.data;
				}
			} catch(e) {
				console.error(e);
			}

			if (isloginRes.login_status && username) {
				this.unlogin = false
			} else {
				this.unlogin = true
			}

			if (!isloginRes.login_status && username) {
				this.unlogin = true
				localStorage.clear()
			}

			if (isloginRes.login_status && !username) {
				this.unlogin = true
				logout().then(() => { })
			}
		},
		showDetail(item) {
			if (item.accessLevel >= 2) {
				if (this.unlogin) {
					Toast.fail('请先登录');
					setTimeout(() => {
						this.$router.push('/login');
					}, 1000);
					return;
				}
				this.showPrompt = true;
				return;
			}
			const targeturl = '/strategy/detail/' + item.id
			this.$router.push({
				path: targeturl
			})
		},
		onContactCustomerService() {
			this.showPrompt = false;
			openUseasyWebChat('老师列表');
		},
		onPurchaseServer() {
			this.showPrompt = false;
			this.$router.push('/subscription');
		},
	}
}
</script>
<style lang="less" scoped>
#strategylist {
	width: 100%;
	height: 100vh;
	display: flex;
	flex-direction: column;
	background-color: #f5f5f5;
	box-sizing: border-box;
}

/* ========== Tab栏 ========== */
.tab-bar {
	display: flex;
	align-items: center;
	background-color: #ffffff;
	padding: 0 20px;
	height: 40px;
	position: relative;
	box-sizing: border-box;
	width: 100%;
	flex-shrink: 0;
}

.tab-item {
	flex: 1;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
}

.tab-text {
	font-size: 14px;
	color: rgba(4, 4, 4, 0.6);
	line-height: 14px;
}

.tab-item.active .tab-text {
	color: #000000;
	font-weight: 600;
	font-size: 14px;
}

.tab-indicator {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 28px;
	height: 3px;
	background-color: #000000;
	border-radius: 1.5px;
}

/* ========== 滚动区域 ========== */
.scroll-view {
	flex: 1;
	overflow-y: auto;
	width: 100%;
	box-sizing: border-box;
	padding-bottom: 60px; /* 为底部tabbar留出空间 */
}

.list-top-spacer {
	height: 8px;
	width: 100%;
}

/* ========== 教师卡片 ========== */
.teacher-card {
	position: relative;
	margin: 0 8px -8px 8px;
	border-radius: 0;
	overflow: hidden;
	background-color: transparent;
	height: 136px;
	z-index: 1;
	cursor: pointer;
}

.teacher-card:last-child {
	margin-bottom: 0;
}

.card-bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 0;
	/* 9-Patch 设置：高度不拉伸，由于原图是 754x272 (2x图)，卡片高 136px */
	border-style: solid;
	border-color: transparent;
	border-width: 0 150px 0 50px; /* CSS 像素：右侧预留 150px 给弧度，左侧预留 50px 给圆角 */
	box-sizing: border-box;
	border-image-slice: 0 300 0 100 fill; /* 对应原图物理像素：右侧 300px 和左侧 100px 绝对不拉伸 */
	border-image-repeat: stretch;
}

/* ========== 右上角标签 ========== */
.card-tag-img {
	position: absolute;
	right: 8px;
	top: 10px;
	width: 100px;
	height: 48px;
	z-index: -1;
	object-fit: contain;
}

/* ========== 卡片内容 ========== */
.card-content {
	position: relative;
	z-index: 1;
	padding: 22px 24px 8px 24px;
}

.card-header {
	margin-bottom: 16px;
}

.card-name-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.card-name-group {
	display: flex;
	align-items: baseline;
}

.card-name {
	font-size: 16px;
	font-weight: 600;
	color: rgba(0, 0, 0, 1);
	line-height: 16px;
}

.card-name-zh {
	font-size: 12px;
	font-weight: 600;
	color: rgba(0, 0, 0, 1);
	margin-left: 4px;
}

.arrow-wrap {
	position: absolute;
	right: 96px;
	top: 22px;
	background-color: rgba(248, 248, 248, 1);
	border-radius: 50%;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
}

/* ========== 收益数据行 ========== */
.card-data {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	margin: 0 0 4px 0;
	padding: 0 8px 10px 8px;
	border-bottom: 1px solid #EEEEEE;
}

.data-item {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.data-item.right-align {
	align-items: center;
}

.data-value {
	font-family: 'Akrobat', 'DIN Alternate', -apple-system, sans-serif;
	font-size: 20px;
	font-weight: 900;
	line-height: 20px;
	margin-bottom: 6px;
}

.data-value.red {
	color: #E02020;
}

.data-value.black {
	color: #000000;
	font-weight: 700;
}

.data-value.risk {
	font-size: 16px;
	font-weight: 500;
	color: #000000;
	line-height: 16px;
	margin-top: 4px;
}

.data-label {
	font-size: 12px;
	color: #8E8E93;
	line-height: 12px;
}

/* ========== 底部区域 ========== */
.card-footer {
	display: flex;
	align-items: center;
	padding-top: 2px;
}

.subscribed-tag {
	background-color: #FFDDC1;
	border-radius: 8px;
	height: 12px;
	padding: 0 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.subscribed-text {
	font-size: 10px;
	color: #5F2F08;
	line-height: 10px;
}

.footer-spacer {
	flex: 1;
}

.subscriber-info {
	display: flex;
	align-items: center;
}

.subscriber-label {
	font-size: 10px;
	color: #8E8E93;
	line-height: 10px;
	margin-right: 4px;
}

.subscriber-count {
	font-size: 10px;
	color: #8E8E93;
	line-height: 10px;
}

/* ========== 底部安全区 ========== */
.bottom-safe {
	height: 8px;
}

.bottom {
	bottom: 0;
	height: 50px;
	position: fixed;
	width: 100%;
	z-index: 999;
}
.card-blur-overlay {
	position: absolute;
	top: 6px;
	left: 8px;
	right: 8px;
	bottom: 9px;
	z-index: 10;
	border-radius: 8px;
	background-color: rgba(0, 0, 0, 0.2);
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-top: 20px;
}
.lock-icon-wrap {
	display: flex;
	justify-content: center;
	align-items: center;
}
.lock-icon {
	width: 40px;
	height: 40px;
}
</style>